import { useEffect, useState } from 'react';
import { SocialProviderUnitDto2 } from '../../../api-service/clients';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { useServiceProviderUnitSelection } from '../../citizen/hooks/use-service-provider-unit-selection';

const client = moduleClientFactory.createCitizenCommunicationClient(true);

let cachedPromise: Promise<SocialProviderUnitDto2[]> | null = null;

function getUnitsOnce(): Promise<SocialProviderUnitDto2[]> {
  if (!cachedPromise) {
    cachedPromise = (async () => {
      try {
        const response = await client.getServiceProviderUnitsForCurrentUser();
        return response.serviceProviderUnits ?? [];
      } catch (e) {
        cachedPromise = null;
        throw e;
      }
    })();
  }
  return cachedPromise;
}

export interface UseServiceProviderUnitsResult {
  units: SocialProviderUnitDto2[];
  currentUnit: SocialProviderUnitDto2 | undefined;
  setCurrentUnit: (unitId: string | undefined) => void;
  isLoading: boolean;
}

export function useServiceProviderUnits(): UseServiceProviderUnitsResult {
  const [units, setUnits] = useState<SocialProviderUnitDto2[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    async function load() {
      try {
        const loaded = await getUnitsOnce();
        if (!cancelled) setUnits(loaded);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const { currentServiceProvider, setCurrentServiceProvider } = useServiceProviderUnitSelection(units);
  const currentUnit = units.find(u => u.id === currentServiceProvider?.id);

  return {
    units,
    currentUnit,
    setCurrentUnit: setCurrentServiceProvider,
    isLoading,
  };
}
